import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BarChartIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3 10.3653C3.55228 10.3653 4 10.813 4 11.3653V14.3653C4 14.9176 3.55228 15.3653 3 15.3653H2C1.44772 15.3653 1 14.9176 1 14.3653V11.3653C1 10.813 1.44772 10.3653 2 10.3653H3ZM14 1.36526C14.5523 1.36526 15 1.81298 15 2.36526V14.3653C15 14.9176 14.5523 15.3653 14 15.3653H13C12.4477 15.3653 12 14.9176 12 14.3653V2.36526C12 1.81298 12.4477 1.36526 13 1.36526H14ZM8.5 5.36526C9.05229 5.36526 9.5 5.81298 9.5 6.36526V14.3653C9.5 14.9176 9.05229 15.3653 8.5 15.3653H7.5C6.94772 15.3653 6.5 14.9176 6.5 14.3653V6.36526C6.5 5.81298 6.94772 5.36526 7.5 5.36526H8.5Z"
		/>
	</svg>
))
